import { useBaseActions } from '../base.actions';
import { idiomasAtom } from './IdiomaState';

function useIdiomasActions() {
  const baseActions = useBaseActions('idiomas', idiomasAtom, false);
 
  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useIdiomasActions };
